import { takeEvery, delay, put } from "redux-saga/effects";
import axios from "axios";

import { profileApi, logoutApi } from "../../../utility/api/apiList";

import userType from "./userType";
import { handleSetDetailForUpdate } from "./userAction";
import { handleLogOutUser } from "./userAction";

export function* handleLogOut(action) {
  try{
    yield axios.post(logoutApi, {refresh:action?.refresh, type:1});
  }catch(e){}
  yield delay(1000);
  yield put(handleLogOutUser());
  yield window.location = '/';
}

export function* userLogOutInSaga() {
  yield takeEvery(userType.START_LOGIN_OUT, handleLogOut);
}

//update userDetail

export function* startUpdateUserDetail(action) {
  try {
    const response = yield axios.get(profileApi);

    const setDetail = yield put(handleSetDetailForUpdate(response.data));
  } catch (error) {
    // yield alert('مشکلی پیش آمده! لطفا بعدا امتحان کنید.')
  }
}

export function* handleUpdateUserDetail() {
  yield takeEvery(userType.UPDATE_USER_DETAIL, startUpdateUserDetail);
}
